import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromToDosActions } from '../actions';
import { IOutstandingTodos } from '../models/outstandingTodos.model';

export const toDosFeatureKey = 'toDos';

export interface ToDosState {
  toDosRequest: string;
  toDosResponse: IOutstandingTodos;
  toDosFailure: IGenericError<ErrorResponse>;
}

export const initialState: ToDosState = {
  toDosRequest: undefined,
  toDosResponse: undefined,
  toDosFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromToDosActions.loadToDos, (state, action) => ({
    ...state,
    toDosRequest: action.request
  })),
  on(fromToDosActions.loadToDosSuccess, (state, action) => ({
    ...state,
    toDosResponse: action.response
  })),
  on(fromToDosActions.loadToDosFailure, (state, action) => ({
    ...state,
    toDosFailure: action.error
  }))
);

export const getToDosRequest = (state: ToDosState) => state.toDosRequest;
export const getToDosResponse = (state: ToDosState) => {
  return state.toDosResponse;
};
export const getToDosFailure = (state: ToDosState) => state.toDosFailure;
